import { IconInfo16 } from '@warp-ds/icons/react/info-16';

type SortDetailsProps = {
    section: string;
    className?: string;
};

export const SortDetails = ({ section, className = '' }: SortDetailsProps) => (
    <div className={`flex gap-8 items-center ${className}`}>
        <IconInfo16 color="#2563eb" />
        <a href={`https://www.finn.no/reise/info/#${section}`} target="_blank" rel="noreferrer" data-testid="sortDetails">
            Slik sorteres søkeresultatene
        </a>
    </div>
);
